import { Control } from "react-hook-form";
import { useIntl } from "react-intl";
import { genders } from "../../../../models/base-user.interface";
import { KeyValue } from "../../../../models/key-value";
import { PatientDetailsFormInputs } from "../../../../models/users.interface";
import SelectFormInput from "../../../Shared/SelectInput/SelectFormInput";

const genderSelectItems: KeyValue<string>[] = [];

for (let i = 0; i < genders.length; i++) {
  const gender = genders[i];
  genderSelectItems.push({
    key: gender,
    value: gender,
  });
}

type GenderSelectFormInputProps = {
  control: Control<PatientDetailsFormInputs, object>;
  required?: boolean;
  disabled?: boolean;
  isInvalid?: boolean;
};

const GenderSelectFormInput = ({
  isInvalid,
  disabled,
  control,
  required = false,
}: GenderSelectFormInputProps) => {
  const intl = useIntl();

  const placeholder = intl.messages[
    "MANAGEMENT.PATIENT_DETAILS.SELECT_GENDER"
  ] as string;

  return (
    <SelectFormInput<PatientDetailsFormInputs>
      name={"gender"}
      control={control}
      rules={{
        required: required,
      }}
      input={{
        items: genderSelectItems,
        disabled: disabled,
        isInvalid: isInvalid,
        placeholder: placeholder,
        className: "px-1",
      }}
    />
  );
};
export default GenderSelectFormInput;
